<template>
<div class="rent-report__table--row__subrow" :class="isContainCity(city) ? 'rent-report__table--row-inner' : ''">
    <div class="rent-report__table--row-cell" :class="isContainCity(city) ? 'rent-report__table--row-cell-inn' : ''"
        @click="showInnerCities">
        <div class="rent-report__table-mob__wrapper">
            <span class="rent-report__table--row-cell--city">{{ city.name }}</span>
            <span>{{ city.hint }}</span>
        </div>
        <svg v-if="isContainCity(city)" :class="isShowInnerList ? 'open' : ''" width="14" height="9" viewBox="0 0 14 9"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6568 7.34314L6.99998 1.68629L1.34313 7.34314" stroke="#252628" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
    <div class="rent-report__table--row-cell__subrow1">
        <div class="rent-report__table--row-cell">{{ city.quantity.th_pieces }}</div>
        <div class="rent-report__table--row-cell"
            :class="isPosi(formatNumber(city.quantity.th_pieces_quarter, 'th_pieces_quarter'))">
            {{ formatNumber(city.quantity.th_pieces_quarter, 'th_pieces_quarter') }}
        </div>
        <div class="rent-report__table--row-cell"
            :class="isPosi(formatNumber(city.quantity.th_pieces_year, 'th_pieces_year'))">
            {{ formatNumber(city.quantity.th_pieces_year, 'th_pieces_year') }}
        </div>
    </div>
    <div class="rent-report__table--row-cell__subrow1">
        <div class="rent-report__table--row-cell">{{ city.time.days }}</div>
        <div class="rent-report__table--row-cell" :class="isPosi(formatNumber(city.time.days_quarter, 'days_quarter'))">
            {{ formatNumber(city.time.days_quarter, 'days_quarter') }}
        </div>
        <div class="rent-report__table--row-cell" :class="isPosi(formatNumber(city.time.days_year, 'days_year'))">
            {{ formatNumber(city.time.days_year, 'days_year') }}
        </div>
    </div>
    <div class="rent-report__table--row-cell__subrow1">
        <div class="rent-report__table--row-cell">{{ city.price.rub }}</div>
        <div class="rent-report__table--row-cell" :class="isPosi(formatNumber(city.price.rub_quarter, 'rub_quarter'))">
            {{ formatNumber(city.price.rub_quarter, 'rub_quarter') }}
        </div>
        <div class="rent-report__table--row-cell" :class="isPosi(formatNumber(city.price.rub_year, 'rub_year'))">
            {{ formatNumber(city.price.rub_year, 'rub_year') }}
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'TableRow',
    components: {},
    mixins: [],
    props: {
        city: {
            type: Object
        },
        idx: {
            type: String
        }
    },
    data() {
        return {
            isShowInnerList: false
        };
    },

    methods: {
        showInnerCities() {
            this.isShowInnerList = !this.isShowInnerList;
            this.$emit('innerList', this.isShowInnerList);
        },
        isContainCity(city) {
            return typeof city['cities'] !== 'undefined';
        },
        formatNumber(val, index = null) {
            if (index === 'days_quarter' || index === 'days_year') {
                let num = Number(val);
                if (num > 0) {
                    num = '+' + num;
                    return num;
                } else return val;
            } if (index === 'th_pieces' || index === 'days' || index === 'rub') {
                return val;
            } else {
                let num = Number(val);
                if (num > 0) {
                    num = '+' + num;
                }
                return num + '%';
            }
        },
        isPosi(val) {
            let regExpPlus = /[+]/g;
            let regExpMinus = /[-]/g;
            let matchesPlus = val.match(regExpPlus);
            let matchesMinus = val.match(regExpMinus);
            if (matchesPlus && matchesPlus.length > 0 || Number(val.replace(',', '.')) > 0) {
                return 'increase';
            } else if (matchesMinus && matchesMinus.length > 0 || Number(val.replace(',', '.')) < 0) {
                return 'decrease';
            } else if (val === '0' || val === 0 || val === '0%') {
                return 'zero';
            } else return;
        }
    }
};
</script>
